import { components } from '../apiTyped/types';
import { I18n } from 'react-redux-i18n';

export const getStateToStatus = (
  posStatus: string
): 'positive' | 'negative' | 'neutral' | null => {
  let state;
  switch (posStatus) {
    case 'pos':
      state = 'positive';
      break;
    case 'lost':
      state = 'negative';
      break;
    case 'todo':
      state = 'neutral';
      break;
    default:
      state = null;
      break;
  }
  return state as 'positive' | 'negative' | 'neutral' | null;
};

export const getColorToState = (posState: string | null) => {
  let color;
  switch (posState) {
    case 'positive':
      color = '#20c997';
      break;
    case 'negative':
      color = '#e25d34';
      break;
    case 'neutral':
      color = '#1f2b37';
      break;
    default:
      color = '#868e96ff';
      break;
  }

  return color;
};

export const getColorToStatus = (posStatus: string) => {
  const state = getStateToStatus(posStatus);
  return getColorToState(state);
};

type Refs = {
  [key: string]: number;
};

export const sortPosByRef = (
  a: Refs | undefined | null,
  b: Refs | undefined | null
) => {
  const sumRefs = (refs: Refs | undefined | null) => {
    if (!refs) return 0;
    return Object.values(refs).reduce((acc, base) => acc + base, 0);
  };

  return sumRefs(b) - sumRefs(a);
};

export const sortPosByBrand = (
  a: Refs | undefined | null,
  b: Refs | undefined | null
) => {
  const sumRefs = (refs: Refs | undefined | null) => {
    if (!refs) return 0;
    return Object.values(refs).length;
  };

  return sumRefs(b) - sumRefs(a);
};

export const formatPos = (item: components['schemas']['PointOfSale']) => ({
  ...item,
  quality: {
    type: item.network_code,
    ws_award: item.ws_award,
    michelin_stars: item.michelin_stars,
    michelin_green_star: item.michelin_green_star
  },
  contact: {
    email: item.email,
    phone: item.phone,
    site: item.site,
    address: item.address,
    latitude: item.latitude,
    longitude: item.longitude
  },
  type: {
    value:
      item.network_code === 'OFF'
        ? I18n.t('wineShopSingular')
        : I18n.t('restaurantSingular'),
    network_code: item.network_code,
    square: item.network_code === 'OFF',
    evolution: getStateToStatus(item.state)
  }
});

export const getOption = (item?: string | number) =>
  !item
    ? null
    : {
        label: String(item),
        value: item
      };
